export default __webpack_public_path__ + "static/media/REMIX.fa1f1552.svg";